import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AbstractService } from './abstract.service';

export interface StatusEnvioDesk {
  configurada: boolean;
  emAndamento: boolean;
  inicio?: number;
  fim?: number;
  total?: number;
  processados?: number;
  criados?: number;
  atualizados?: number;
  erros?: number;
  ultimoErro?: string;
}

@Injectable({
  providedIn: 'root'
})
export class IntegracaoDeskService {

  constructor(private http: HttpClient) { }

  status(): Observable<StatusEnvioDesk> {
    return this.http.get<StatusEnvioDesk>(this.url('/status'), { headers: this.headers() });
  }

  enviarTodos(): Observable<StatusEnvioDesk> {
    return this.http.post<StatusEnvioDesk>(this.url('/enviar-todos'), null, { headers: this.headers() });
  }

  private url(caminho: string): string {
    return environment.api.replace(/\/+$/, '') + '/admin/integracao-desk' + caminho;
  }

  private headers(): HttpHeaders {
    return new HttpHeaders({
      Accept: 'application/json; charset=utf-8',
      'X-Auth-Token': AbstractService.token(),
    });
  }
}
